// removed by extract-text-webpack-plugin
module.exports = {"container":"___Register__container___2LCho"};


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Register/Register.less
// module id = 1028
// module chunks = 0